import { message } from "antd";
import { navigate } from "@reach/router";
import { getUserByID } from "../graphQl/queries/users";
import { ROLE_AFFILIATE, getDashboardPathForRole } from "./roles";
import { captureException } from "./sentry";

export const fetchUserAuthContext = async (client, userId) => {
  const { data } = await client.query({
    fetchPolicy: "network-only",
    query: getUserByID,
    variables: { id: userId },
  });

  const user = data?.UserByID;
  if (!user) {
    return null;
  }

  const agencyID =
    user.extra?.agencyID != null ? String(user.extra.agencyID) : null;

  return {
    roleID: user.roleID,
    agencyID,
  };
};

const validateAuthContext = authContext => {
  if (!authContext || authContext.roleID == null) {
    return { valid: false, reason: "role" };
  }

  if (authContext.roleID !== ROLE_AFFILIATE && !authContext.agencyID) {
    return { valid: false, reason: "agency" };
  }

  return { valid: true };
};

export const redirectToDashboardForRole = async (client, userId) => {
  try {
    const authContext = await fetchUserAuthContext(client, userId);
    const validation = validateAuthContext(authContext);

    if (!validation.valid) {
      if (validation.reason === "agency") {
        message.error("No se encontró la agencia asociada al usuario.");
      }
      return null;
    }

    navigate(
      getDashboardPathForRole(authContext.roleID, userId, authContext.agencyID)
    );
    return authContext;
  } catch (error) {
    captureException(error);
    throw error;
  }
};
